import { GLOBAL_BLOCK_DRAG_HANDLE, HORIZONTAL_STACK_DRAG_HANDLE, INSERT_NEW_SECTION_HANDLE, MODULE_DRAG_HANDLE, REUSABLE_BLOCK_DRAG_HANDLE, SECTION_DRAG_HANDLE, TABLE_DRAG_HANDLE, VERTICAL_STACK_DRAG_HANDLE } from '../constants/dnd';
import { isVerticalStackHoverPosition, isModuleHoverPosition, isHorizontalStackHoverPosition, isTableHoverPosition, isGlobalBlockHoverPosition, isReusableBlockHoverPosition } from '../hoverPositions/gridLayoutTreeHoverPositionUtils';

// TODO: Support a cap on the number of drag handles created
export function calculateDragHandlesFromHoverPositions(hoverPositions) {
  // TODO: Figure out if this case is one we want to support\
  // https://git.hubteam.com/HubSpot/content-editor-ui-v2/pull/287/files#r4919831
  // if (
  //   hoverPositions.length === 0 ||
  //   hoverPositions[0].type === hoverTypes.OUTSIDE_LAYOUT_SECTION
  // ) {
  //   return null;
  // }

  // This case is to avoid showing a drag handle in situations where hover positions
  // are generated but you're not directly over a node. We may no longer need this
  // on the new pegboard based approach we're taking.
  // Context: https://git.hubteam.com/HubSpot/layout-dnd-lib/pull/691#discussion_r5033885
  //
  // if (hoverPositions[0].type !== hoverTypes.INNER_TRIANGLE) {
  //   hoverPositions = hoverPositions.slice(1);
  // }

  let nextHoverPosition;
  let foundModule = false;
  const handlesToGather = [];
  for (let i = 0; i < hoverPositions.length; i++) {
    const currHoverPosition = hoverPositions[i];
    nextHoverPosition = hoverPositions[i + 1];
    if (!foundModule && isModuleHoverPosition(currHoverPosition)) {
      var _nextHoverPosition;
      const moduleDragHandle = {
        gridLayoutId: currHoverPosition.gridLayoutId,
        type: MODULE_DRAG_HANDLE,
        depth: currHoverPosition.depth,
        id: currHoverPosition.id,
        parentId: (_nextHoverPosition = nextHoverPosition) === null || _nextHoverPosition === void 0 ? void 0 : _nextHoverPosition.id
      };
      // Special case early abort of drag handle computation if the module being
      // hovered over has a chance of overlaping other nodes in the tree
      if (
      // @ts-expect-error shh, they should be here
      currHoverPosition.isFixedPosition ||
      // @ts-expect-error shh, they should be here
      currHoverPosition.isAbsolutePosition) {
        return [moduleDragHandle];
      } else {
        handlesToGather.push(moduleDragHandle);
      }
      foundModule = true;
    } else if (isVerticalStackHoverPosition(currHoverPosition)) {
      var _nextHoverPosition2;
      handlesToGather.push({
        gridLayoutId: currHoverPosition.gridLayoutId,
        type: VERTICAL_STACK_DRAG_HANDLE,
        depth: currHoverPosition.depth,
        id: currHoverPosition.id,
        parentId: (_nextHoverPosition2 = nextHoverPosition) === null || _nextHoverPosition2 === void 0 ? void 0 : _nextHoverPosition2.id
      });
    } else if (isHorizontalStackHoverPosition(currHoverPosition)) {
      var _nextHoverPosition3;
      handlesToGather.push({
        gridLayoutId: currHoverPosition.gridLayoutId,
        type: HORIZONTAL_STACK_DRAG_HANDLE,
        depth: currHoverPosition.depth,
        id: currHoverPosition.id,
        parentId: (_nextHoverPosition3 = nextHoverPosition) === null || _nextHoverPosition3 === void 0 ? void 0 : _nextHoverPosition3.id
      });
    } else if (isTableHoverPosition(currHoverPosition)) {
      var _nextHoverPosition4;
      handlesToGather.push({
        gridLayoutId: currHoverPosition.gridLayoutId,
        type: TABLE_DRAG_HANDLE,
        depth: currHoverPosition.depth,
        id: currHoverPosition.id,
        parentId: (_nextHoverPosition4 = nextHoverPosition) === null || _nextHoverPosition4 === void 0 ? void 0 : _nextHoverPosition4.id
      });
    } else if (isReusableBlockHoverPosition(currHoverPosition)) {
      var _nextHoverPosition5;
      handlesToGather.push({
        id: currHoverPosition.id,
        uniquePositionId: currHoverPosition.uniquePositionId,
        type: REUSABLE_BLOCK_DRAG_HANDLE,
        depth: currHoverPosition.depth,
        gridLayoutId: currHoverPosition.gridLayoutId,
        parentId: (_nextHoverPosition5 = nextHoverPosition) === null || _nextHoverPosition5 === void 0 ? void 0 : _nextHoverPosition5.id
      });
    } else if (isGlobalBlockHoverPosition(currHoverPosition)) {
      handlesToGather.push({
        id: currHoverPosition.id,
        uniquePositionId: currHoverPosition.uniquePositionId,
        type: GLOBAL_BLOCK_DRAG_HANDLE
      });
    }
  }
  const sectionId = hoverPositions.length > 1 ? hoverPositions[hoverPositions.length - 2].id : null;
  if (sectionId) {
    const sectionPosition = hoverPositions[hoverPositions.length - 2];
    const parentPosition = hoverPositions[hoverPositions.length - 1];
    handlesToGather.push({
      id: sectionId,
      parentId: parentPosition.id,
      gridLayoutId: sectionPosition.gridLayoutId,
      type: INSERT_NEW_SECTION_HANDLE,
      depth: hoverPositions[hoverPositions.length - 2].depth
    });
    handlesToGather.push({
      id: sectionId,
      parentId: parentPosition.id,
      gridLayoutId: sectionPosition.gridLayoutId,
      type: SECTION_DRAG_HANDLE,
      depth: sectionPosition.depth
    });
  }
  return handlesToGather;
}